SurveyAction = require('sma.applicant/surveys/logic.coffee').SurveyAction
BranchingRule = require('sma.applicant/surveys/logic.coffee').BranchingRule
SurveyRedirectException = require('sma.applicant/surveys/logic.coffee').SurveyRedirectException

StringVariable = require('sma.applicant/surveys/variables.coffee').StringVariable
SingleChoiceVariable = require('sma.applicant/surveys/variables.coffee').SingleChoiceVariable
MultipleChoiceVariable = require('sma.applicant/surveys/variables.coffee').MultipleChoiceVariable
DateTimeVariable = require('sma.applicant/surveys/variables.coffee').DateTimeVariable

randomString = (length) =>
	chars =	'0123456789' + 'ABCDEFGHIJKLMNOPQRSTUVWXTZ' + 'abcdefghiklmnopqrstuvwxyz'

	random = ''
	for i in [0...length]
		rnum = Math.floor(Math.random() * chars.length)
		random += chars.substring(rnum, rnum + 1)

	return random

class SurveyError extends Error
	name: 'SurveyError'

	constructor: (@message) -> super message

class Looping
	getLoopedObject: (obj, loopedFor) ->
		root = obj._underlying ? obj

		copy = _.object(root)
		copy._underlying = root

		copy.loopedFor = loopedFor

		copy.id = "#{root.id}:#{[item.id for item in loopedFor].join(':')}"

		copy.buildLoopedObject?()

		return copy

cacher = (func) ->
	cached = "_#{randomString(10)}"

	result = ->
		return @[cached] if @[cached]?
		@[cached] = func.apply(this, arguments)
		return @[cached]

	result.clear = ->
		@[cached] = null

	return result

class Page
	# contains any rules from previous pages that will apply on this one
	targetRules: undefined

	@create: (index, info) ->
		page = new this(info)
		page.index = index
		return page

	constructor: (info) ->
		@id = info.id ? randomString(5)
		@label = trans.make info.label if info.label?
		@questions = (Question.create question for question in info.children ? info.questions ? [])

		@randomize = info.randomize ? false

		@skip = info.branching?[0]?.uncondition ? info.skip
		if @skip
			@skip = BranchingRule::parseAction skip: @skip

		@branching = if info.branching? then (BranchingRule::parse(rule) for rule in info.branching) else undefined

	toString: ->
		label = if @label? then @label.toString() else "Page #{@index + 1}"

		return label unless @loopedFor?.length

		loops = ("#{el.source.get('name')}=\"#{el.label}\"" for el in @loopedFor).join(', ')

		return "#{label} (looped: #{loops})"

	buildLoopedObject: ->
		@questions = (Looping::getLoopedObject(question, @loopedFor) for question in @questions)

	variables: ->
		result = {}

		for question in @questions
			for key, variable of question.variables()
				result[variable.id] = variable

		return result

	applyTargetRules: (handler, el) ->
		deferred_actions =
			'hide': {}
			'show': {}

		for rule in @targetRules ? []
			for action in rule.actions
				if action.type in ['hide', 'show']
					deferred_actions[action.type][action.target] = (deferred_actions[action.type][action.target] or []).concat([rule.condition])
				else if action.hasTargets
					action.apply(handler.evaluateCondition(rule.condition), el)
		for rule_type, targets of deferred_actions
			for target, rules of targets
				(new SurveyAction.TYPES[rule_type](target)).apply handler.evaluateCondition(new OrNode(rules)), el

	dynamics: -> _.flatten (question.dynamics() ? [] for question in @questions), true

	hiddenFor: (handler) ->
		for rule in @hideRules ? []
			if handler.evaluateCondition(rule.condition)
				return yes

		return no

class Survey
	metaVariables:
		_key: new StringVariable
			id: '_key'

		_created_at: new DateTimeVariable
			id: '_created_at'
			format: 'datetimetz'

		_updated_at: new DateTimeVariable
			id: '_updated_at'
			format: 'datetimetz'

		_completed: new SingleChoiceVariable
			id: '_completed'

		_weighted_score: new StringVariable
			id: '_weighted_score'

	constructor: (info) ->
		@id = info.id
		@pages = (Page.create(index, page) for page, index in info.form ? info.pages ? [])
		@title = trans.make info.title ? ''
		@description = trans.make info.description ? ''
		@options =
			titleOnlyFirstPage: info.firstPageTitleDescription

		@languages = []
		@defaultLanguage = info.defaultLanguage

		for language in info.languages ? ['en']
			if language.code?
				@languages.push language.code
				@defaultLanguage = language.code if !@defaultLanguage or language.isDefault
			else
				@languages.push language
				@defaultLanguage = language if !@defaultLangauge

		# Change the info dictionary in-place to update to new format, and update trans global
		info.languages = trans::availableLanguages = @languages
		info.defaultLanguage = trans::defaultLanguage = @defaultLanguage

		trans::language = @defaultLanguage

		@loops = @parseLoops(info)

		# Redistribute any target rules to the pages that contain their target
		for page in @pages
			# Run any custom question code here (e.g. extraction updating)
			for question in page.questions
				question.onSurveyBuilt this

			for rule in (page.branching ? []).concat(page.dynamics() ? [])
				for action in rule.actions
					if action.hasTargets
						targetPage = @resolvePage(action.target)

						if not targetPage?
							console.warn "Branching rule target [#{action.target}] cannot be found, skipping..."
							continue

						(targetPage.targetRules ?= []).push(rule)

					else if action.type == 'hide-page'
						targetPage = action.getPage(this)

						if not targetPage?
							console.warn "Branching rule target [#{action.target}] cannot be found, skipping..."
							continue

						(targetPage.hideRules ?= []).push(rule)

	loopedPages: -> @_loopedPages ?= @expandLoops @buildLoopTree @loops

	expandLoops: (loops, pages, offset=0) ->
		pages ?= @pages.slice()

		loops = loops.slice().reverse()

		for [el, children] in loops
			base = pages.splice(el.range[0] - offset, el.range[1] - el.range[0] + 1)

			base = @expandLoops children, base, el.range[0]

			looped = []

			# FIXME
			source = @resolve(el.source)

			if not source?
				console.warn "Could not find loop source [#{el.source}] for pages #{el.range[0] + 1}-#{el.range[1] + 1}, skipping..."
				continue

			if not source.getExtraction?
				console.warn "Loop source [#{el.source}] for pages #{el.range[0] + 1}-#{el.range[1] + 1} does not support extraction, skipping..."
				continue

			for j in source.getExtraction(undefined, el.options) ? []
				looped = looped.concat _.map base, (obj) ->
					loopedFor = (obj.loopedFor ? []).slice()
					loopedFor.unshift
						id: j.id
						label: j.label()
						source: source
						loop: el
					return Looping::getLoopedObject(obj, loopedFor)

			pages.splice.apply(pages, [el.range[0] - offset, 0].concat(looped))

		return pages

	buildLoopTree: (loops) ->
		end = -1

		keyFunc = (el) ->
			if el.range[0] > end
				end = el.range[1]
			return end

		grouped = _.groupBy(loops, keyFunc)

		return _.map grouped, (el) =>
			parent = el.shift()
			return [parent, @buildLoopTree el]

	parseLoops: (info) ->
		loops = []

		for page in info.form ? info.pages ? []
			for question in page.children ? page.questions ? []
				if question.looping?
					loops.push
						source: question.id
						range: question.looping.range
						options: question.looping.options

		return loops

	@pipe: (txt) ->
		txt
		#txt.toString().replace /\{\{\s*([^\{\}]+)\s*\}\}/g, '<span data-piping-expr="$1" />'

	@pipeAttr: (txt) ->
		if txt.toString().search(/\{\{\s*([^\{\}]+)\s*\}\}/g) < 0
			return ""

		txt = txt.toString().replace '"', '\\"'

		return "data-piping=\"#{txt}\""

	resolveName: (name) ->
		match = /^([a-zA-Z0-9\-]+)(?:_(\d+))?$/.exec(name)

		return null unless match?

		question = @nameMap()[match[1]]

		return null unless question?

		return if match[2]? then "#{question.id}_#{match[2]}" else question.id

	nameMap: cacher ->
		mapping = {}
		for page in @pages
			for question in page.questions
				mapping[question.get('name')] = question if question.get('name')
		return mapping

	resolve: (ref) ->
		if (match = /([a-zA-Z0-9]+)_(\d+)/.exec(ref))?
			ref = match[1]

		return @questions()[ref]

	resolvePage: (ref) ->
		return @resolve(ref)?.page

	questions: cacher ->
		questions = {}
		for page in @pages
			for question in page.questions
				questions[question.id] = _.extend _.object(question), page: page
		return questions

	variables: cacher -> _.extend {}, (page.variables() for page in @loopedPages())...

	variablesByName: ->
		result = {}
		for id, variable of @variables()
			if variable.name()
				result[variable.name()] = variable
		return result

	resolveVariable: (name) ->
		variables = @variables()

		return variables[name] if name of variables

		id = @resolveName name

		return null unless id?

		return variables[id]

	getResponses: -> JSON.parse(localStorage["survey.#{@id}.responses"] ? "[]")

	setResponses: (value) ->
		delete localStorage["survey.#{@id}.responses"]
		localStorage["survey.#{@id}.responses"] = JSON.stringify(value)

	deleteResponses: (keys...) ->
		for key in keys
			delete localStorage["responses.#{key}"]

		@setResponses(_.without @getResponses(), keys...)

class Response
	constructor: (@survey, key) ->
		@key = key ? randomString 10
		@createdAt = new _.date()
		@updatedAt = new _.date()
		@completed = 0
		@weightedScore = 0
		@values = {}

		if key?
			@load()

	load: ->

	save: ->

	names: (el) ->
		_.uniq $(':input[name]:not(:button,:submit)', el).map -> $(this).attr 'name'

	loadForm: (el, page) ->
		return unless @values?

		names = @names(el)
		variables = page.variables()

		for name, variable of variables
			if name of @values
				variable.loadForm el, @values[name]

		@weightedScore = @values['_weighted_score'] = @getCurrentScore page

	saveForm: (el, page) ->
		# disable invalid other choices before serializing
		disabled = $("li:not(:has(:checked)) :input[name$=_other]:enabled", el).attr('disabled', 'disabled')

		vals = $('form', el).serializeArray()

		# re-enable
		disabled.removeAttr('disabled')

		variables = page.variables()

		form = {}

		for val in vals
			(form[val.name] ?= []).push(val.value)

		@values ?= {}

		for name, variable of variables
			variable.saveForm(form, @values)

		@save()

	getCurrentScore: (current_page) ->
		score = 0
		return score unless @values?

		for page in @survey.pages when page.index < current_page.index
			variables = page.variables()
			for name, variable of variables
				if variable.type in ['boolean', 'single', 'multi']
					score += variable.getScore @values[name]
		return score

class LocalResponse extends Response
	load: ->
		value = localStorage["responses.#{@key}"]

		@values = if value? then JSON.parse value else {}

		@updatedAt = if @values?._updated_at then new _.date(@values._updated_at) else undefined
		@createdAt = if @values?._created_at then new _.date(@values._created_at) else undefined

		@completed = @values?._completed ? 0

	save: (skipUpdate = false) ->
		@updatedAt = new _.date() unless skipUpdate

		@values._created_at = @createdAt
		@values._updated_at = @updatedAt
		@values._completed = @completed

		delete localStorage["responses.#{@key}"]
		localStorage["responses.#{@key}"] = JSON.stringify @values

		allResponses = @survey.getResponses()

		allResponses.push(@key) if @key not in allResponses

		@survey.setResponses(allResponses)

	getTotalScore: ->
		score = 0
		return String(score) unless @values?

		for page in @survey.pages
			variables = page.variables()
			for name, variable of variables
				if variable.type in ['boolean', 'single', 'multi']
					vscore = variable.getScore @values[name]
					if vscore? then score += vscore

		return String(score)

class Handler
	constructor: (@survey, @response, options, style_json={}) ->
		@options = SurveyOptions.parse options
		@style_json = style_json

		@expr_mapping = {}
		@parser = new ExprParser()

	validate: (page) ->
		valid = true

		$('.error-placeholder').empty().hide()
		if page.branching
			for rule in page.branching
				if rule.actions[0] instanceof InvalidAction and @evaluateCondition(rule.condition)
					valid = false
					placeholder = $("#error_#{rule.actions[0].target}")
					placeholder.append """<ul class="errorlist"><li>#{rule.actions[0].feedback}</li></ul>"""
					placeholder.show()

		for question in page.questions
			variables = question.variables()
			if (extraction = question.get('extraction'))?
				enabled = extraction.evaluate(@)
				for k, variable of variables
					if k not of enabled
						delete variables[k]
			for k, variable of variables
				# skip validating this variable if it is hidden or disabled - should
				# be fixed so that the selector is scoped, but that also applies to finding
				# error placeholders below
				continue if $("[name=#{variable.escapedId()}]").is('.hidden, :disabled')

				try
					variable.validateResponse @response
				catch e
					valid = false
					placeholder = $("#error_#{variable.escapedId()}")
					placeholder.append """<ul class="errorlist"><li>#{e.message.toString()}</li></ul>"""
					placeholder.show()

			try
				if !($('#x_' + question.escapedId()).css('display') == 'none')
					question.validateResponse @response
			catch e
				valid = false
				placeholder = $("#error_#{question.escapedId()}")
				placeholder.append """<ul class="errorlist"><li>#{e.message.toString()}</li></ul>"""
				placeholder.show()


		if not valid

			first = $('.error-placeholder:not(:empty) .errorlist').eq(0)
				.parents('.question:eq(0)')

			if first.length
				first.scrollTo()
					.end()
					.flash({backgroundColor:'#A27D34'}, 1000)
					.flash({backgroundColor:'#A27D34'}, 1000)

		return valid

	progressBarTemplate: _.template '''
	<div class="progress-bar">
		<div class="bar" style="width: <%= progress %>%;"></div>
		<span class="progress"><%= progress %>%</span>
	</div>
	'''

	getProgress: (page) ->
		pages = @survey.loopedPages()

		return 100 if not page? or page == 'f' or page == 't'

		return parseInt(pages.indexOf(page) * 100 / pages.length, 10)

	createStyle: (css) ->
		el = $('<style type="text/css"/>')

		if el[0].styleSheet
			el[0].styleSheet.cssText = css
		else
			el.text(css)

		return el

	getThemeCss: ->
		rules = {}

		if @options.get('style.background_image')
			rules['body.survey'] = {'background-image': "url(#{@options.get('style.background_image')})"}

		for options_dict in [@style_json, @options.get('style.css')]
			for selector, items of options_dict
				selector = selector
					.replace(/^(.*?)\ *(,?\ *html\ *,?)\ *(.*)/,'$1$3')
					.replace(/^(body)/,'$1.survey')
					.replace(/^(div#main div#survey)/,'#survey')
					.replace(/^(#survey #x|#x)(.*)$/,'$1_$2')
					.replace(/^.*?\.header-progress-container(.*)$/,'#survey .survey-header$1')
					.replace(/^.*?\.survey-progress-outer(.*)$/,'#survey .progress-bar$1')
					.replace(/^.*?\.survey-progress-inner(.*)$/,'#survey .progress-bar .bar$1')
				_.each items, (v, p) ->
					if selector.match /\#survey$/
						if p == 'width'
							delete items[p]
					if selector.match /body\.survey$/
						if p == 'margin-top'
							delete items[p]
				rules[selector] = items if !_.isEmpty(items)

		# FIXME: parse additional rules from style.css

		formatStyles = (styles) -> (_.map styles, (value, property) -> "#{property}:#{value};").join('')
		return (_.map rules, (styles, selector) -> "#{selector}{#{formatStyles styles}}" if !_.isEmpty(styles)).join('\n')

	getThemeStyle: ->
		@createStyle @getThemeCss()

	invalidateContext: ->
		@context = undefined

	buildContext: ->
		return @context if @context?

		fixName = (name) ->
			name = name.replace /\-/g, '_'
			return if not isNaN(name[0]) then '_' + name else name

		@context = _.extend
						'collector': {},
						'user': {},
						'invite': {},
						'get_variable': {},
						'metas':{}
					, @response.values

		@context.metas =
			weighted_score: => @response.weightedScore

		for page in @survey.loopedPages()
			loopId = ''
			for entry in page.loopedFor ? []
				loopId += ':' + entry.id

			sameLoop = @currentPage.loopedFor and page.loopedFor and \
				@currentPage.loopedFor[0].loop == page.loopedFor[0].loop and \
				@currentPage.loopedFor[0].id == page.loopedFor[0].id

			for question in page.questions
				if question.name()
					q_name = fixName question.name()

					question_name = q_name + loopId

					if question instanceof Question.ThreeDGrid
						@context[question_name] = new ThreeDMatrixContext(question, @response.values)
					else
						@context[question_name] = new QuestionContext(question, @response.values)

					if sameLoop
						@context[q_name] = @context[question_name]

					index = 0
					for i,variable of question.variables()
						variable_name = fixName variable.name()
						if variable_name.indexOf('other.')>=0
							new_variable_name = variable_name.replace /\./g, '_'
						else
							variable_name = variable_name.split('\.')
							new_variable_name =  variable_name[0] + '_'+ index
						variable_name = new_variable_name + loopId

						@context[variable_name] = new VariableContext(variable, @response.values)
						if sameLoop
							@context[new_variable_name] = @context[variable_name]
						index++

			# extend with current looping items
			for entry in @currentPage.loopedFor ? []
				# We can't use entry.label here, since for certain extraction/looping types
				# (e.g. from text response grid) the piped label changes depending on the
				# response, since the one built while expanding looping doesn't have access
				# to it. We need to re-calculate the extracted items using the response
				# here and find the right one by id.
				extraction = entry.source.getExtraction(@response, entry.loop.options)

				item = _.find extraction, (item) -> item.id == entry.id

				@context[entry.source.name()] = item?.label?()

		return @context

	renderSurveyHeader: (page) ->
		el = $('<div class="survey-header clearfix"/>')

		el.append $('<img class="survey-logo"/>').attr('src', @options.get('style.logo')) if @options.get('style.logo')

		right = $('<div class="right"/>').appendTo el

		if @survey.languages.length > 1
			langForm = $('<form class="language-select"/>').appendTo right

			dropdown = trans.localizedDropdown()

			langForm.append "Language: ", dropdown, " <input type=\"submit\" value=\"Go\" class=\"button-smaller\" />"

		if not @survey.options.titleOnlyFirstPage or page.index == 0
			el.append $('<h1 class="survey-title"/>').html @survey.title.toString() if @survey.title

			el.append $('<div class="survey-description"/>').html @survey.description.toString() if @survey.description

		return el

	updateExprPiping: (piped) ->
		i = 0
		while i < piped.el_list.length
			el = piped.el_list[i]
			matched = el.expr.match(/\{\{\s*([^\{\}]+)\s*\}\}/g)
			replaced = el.expr
			j = 0

			while j < matched.length
				expression = $.trim(matched[j].replace("{{", "").replace("}}", ""))
				parsedNode = @expr_mapping[expression].parsedNode
				if parsedNode
					try
						piped_value = parsedNode.evaluate(@)
						if piped_value.label
							value = piped_value.label()
						else
							value = piped_value
					catch error
						value = "error"
				else
					value = "error"
				replaced = replaced.replace(matched[j], value)
				j++
			el.el.nodeValue = replaced
			i++

	updatePiping: (form, page) ->
		# TODO: could be cached for speed
		vars = @survey.variablesByName()
		ids = @survey.variables()
		piped = {}

		for entry in page.loopedFor ? []
			if entry.source.name()
				# We can't use entry.label here, since for certain extraction/looping types
				# (e.g. from text response grid) the piped label changes depending on the
				# response, since the one built while expanding looping doesn't have access
				# to it. We need to re-calculate the extracted items using the response
				# here and find the right one by id.
				extraction = entry.source.getExtraction(@response, entry.loop.options)

				item = _.find extraction, (item) -> item.id == entry.id

				piped[entry.source.name()] = item?.label?()

		for expr of @expr_mapping
			@updateExprPiping @expr_mapping[expr]

	renderPage: (page) ->
		@invalidateContext()

		el = document.createDocumentFragment()

		renderQuestions = if page.randomize then _(page.questions).shuffled() else page.questions

		for question in renderQuestions
			rendered = question.render()
			question.setupElement rendered, this
			el.appendChild rendered[0]

		buttons = $('<div class="buttons"/>')

		if _.indexOf(@survey.loopedPages(), page) > 0 && this.options.attributes['buttons.back'] != false
			buttons.append $("<input class='button back' type='button' value='#{@options.get('strings.buttons.back')}' />")

		if _.indexOf(@survey.loopedPages(), page) == @survey.loopedPages().length - 1
			buttons.append " <input class='button' type='submit' value='#{@options.get('strings.buttons.submit')}' />"
		else
			buttons.append " <input class='button' type='submit' value='#{@options.get('strings.buttons.next')}' />"

		el.appendChild buttons[0]

		@response.loadForm el, page

		@generateExprMapping $(el)[0]

		el = $('<form class="survey-form" method="post" action=""/>').append el

		@updatePiping el, page

		page.applyTargetRules this, el

		setTimeout (=>
			$('.question-body:visible', el).each ->
				$(@).css('overflow', 'visible') if /Android/.test(navigator.userAgent)
			if $('.rank-variable-bin, .rank-choice-bin', el).is(':visible')
				$('.rank-variable-bin, .rank-choice-bin', el).height Math.max($('.rank-variable-bin').height(), $('.rank-choice-bin').height())

			), 0

		return el

	renderFinishPage: ->
		$('<div class="survey-finish" />').html @options.get('strings.thankyou').toString()

	renderTerminatePage: ->
		$('<div class="survey-terminate" />').html @options.get('strings.terminated').toString()

	buildPagePath: (stop) ->
		pages = @survey.loopedPages()

		page = pages[0]
		path = [page]

		while pages.indexOf(page) < pages.indexOf(stop)
			try
				page = @getNextPage(page)
			catch e
				break
			path.push(page)

		return path

	getNextPage: (page) ->
		nextPage = null

		for question in page.questions ? []
			for rule in question.getSimpleBranching?() ? []

				for action in rule.actions

					if action.isBranch and @evaluateCondition(rule.condition)
						nextPage = action.apply(@survey)
						break
				break if nextPage?
			break if nextPage?

		for rule in page.branching ? []
			for action in rule.actions
				if action.isBranch and @evaluateCondition(rule.condition)
					nextPage = action.apply(@survey)
					break
			break if nextPage?

		if not nextPage? and page.skip
			nextPage = page.skip.apply(@survey)

		if not nextPage?
			nextPage = @survey.loopedPages()[@survey.loopedPages().indexOf(page) + 1]

		page = nextPage

		# skip any pages that are hidden due to looping
		while page?
			skipping = page.hiddenFor(this)

			if not skipping and page?.loopedFor?.length
				for item in page.loopedFor
					extraction = (choice.id for choice in item.source.getExtraction(@response, item.loop.options))

					if item.id not in extraction
						skipping = yes
						break

			break if not skipping

			page = @survey.loopedPages()[@survey.loopedPages().indexOf(page) + 1]

		return page

	getPreviousPage: (page) ->
		path = @buildPagePath(page)

		return path[path.length - 2]

	evaluateCondition: (condition) -> condition.evaluate(this)

	extractExpr: (node) ->
		matched = node.nodeValue.match(/\{\{\s*([^\{\}]+)\s*\}\}/g)
		if matched and matched.length
			i = 0
			while i < matched.length
				expression = $.trim(matched[i].replace("{{", "").replace("}}", ""))
				if expression of @expr_mapping
					mapped = @expr_mapping[expression]
					mapped.el_list.push
						expr: node.nodeValue
						el: node
				else
					mapped = {}
					try
						mapped.parsedNode = @parser.parse(expression)
					mapped.el_list = [
						expr: node.nodeValue
						el: node
					]
					@expr_mapping[expression] = mapped
				i++

	generateExprMapping: (root) ->
		if root.nodeName.toLowerCase() is "#text"
			@extractExpr root
		else
			for attr of root.attributes
				@extractExpr root.attributes[attr]  if root.attributes[attr] instanceof Attr
			i = 0

			while i < root.childNodes.length
				@generateExprMapping root.childNodes[i]
				i++

	initializeBehaviors: (el) ->
		# force unique dynamic behavior
		el.delegate '.force-unique :radio, .force-unique :checkbox', 'change', (e) ->

			value = $(e.target).val()

			$(e.target).closest('.force-unique')
				.find(':input:checked').filter(-> @value == value).not(e.target)
				.attr('checked', false)

		# allow unchecking radio buttons
		el.delegate ':radio', 'click', (e) ->
			if $(e.target).data('checked')
				$(e.target).removeAttr('checked')
				$(e.target).data('checked', false)
				e.preventDefault()
			else
				$(e.target).data('checked', true)

		el.delegate ':radio', 'focus', (e) ->
			$(e.target).data('checked', !!$(e.target).attr('checked'))

		# calculate the sum of a set of text inputs
		calcTotal = (inputs) ->
			total = 0

			inputs.each (i) ->
				value = $(this).val().replace(',', '.').replace(' ', '')

				if value.match(/^(\d+)|(\d*\.\d+)$/)
					total += if value.indexOf('.') < 0 then parseInt(value, 10) else parseFloat(value)

			return total

		# update the total information at the bottom of text grid questions
		updateTotal = (question) ->
			label = $('.sum-label', question)
			value = label.attr('data:label').replace('{x}', label.attr('data:sum')).replace('{y}', calcTotal($('input', question)))
			value = Survey.pipe value
			label.empty()
			label.append(value)
			# TODO: FIX handler
			#if handler.currentPage
			#	handler.updatePiping handler.el, handler.currentPage

		el.delegate '.question-text-response-grid .sum-inputs input', 'keyup change', (e) ->
			question = $(e.target).closest('.question-text-response-grid')

			updateTotal(question)

		# update totals at bottom of 3d matrix questions
		update3dTotals = (question) ->
			$('.sum-label', question).each ->
				$(this).text(calcTotal($(".#{$(this).attr('data:target')} input", question)))

		el.delegate '.question-threed-grid .sum-inputs input', 'keyup change', (e) ->
			question = $(e.target).closest('.question-threed-grid')

			update3dTotals(question)

		# update totals when page is rendered
		el.bind 'initialize', ->
			$('.question-text-response-grid:has(.sum-inputs)', el).each ->
				updateTotal(this)

			$('.question-threed-grid:has(.sum-label)', el).each ->
				update3dTotals(this)
			# TODO: fix handler
			#if handler.currentPage
			#	handler.updatePiping this, handler.currentPage

		# Correctly render drilldown questions
		el.bind 'initialize', ->
			$('select.drilldown').hide().each (i, el) ->
				name = $(el).attr('name')

				choices = $ '<select>',
					size: 5
					class: 'drill-down-selector'
					change: -> $(el).val $('option:selected', this).val()

				categories = $ '<select>',
					size: 5
					class: 'drill-down-selector'
					change: ->
						choices.empty()
						group = $('option:selected', this).data('optgroup');
						if group
							group.find('option').clone().appendTo(choices)
							choices.val $(el).val()

				$('optgroup', el).each (j, nl) ->
					categories.append $('<option />',
						val: j
						text: $(nl).attr('label')
						data:
							optgroup: $(nl))

					if $('option:selected', nl).length
						categories.val(j)

				choices.insertAfter el
				categories.insertAfter el
				categories.trigger 'change'

		# star rating renderer
		el.bind 'initialize', ->
			$('.star-container input', el).rating()

			# ranking question
			if $().draggable? and $().droppable?
				$.each $('.ranking-question'), (i, el) ->
					original = $('#original-question', el);
					$('#original-question input:checked', el).each  (i) ->
						ids=this.id.split '_'
						choice_index = ids[3]
						variable_index = "#{ids[1]}_#{ids[2]}"
						choice_index_span = $('.rank_index',el).filter () ->
							$(this).text() == choice_index

						choice_div = $(choice_index_span).parent();
						variable_index_span = $('.variable_index',el).filter () ->
							$(this).text() == variable_index

						variable_div = $(variable_index_span).parent()
						$(choice_div).children('.droppable-rank-variable-text').hide()
						$(choice_div).append($(variable_div))
						$(variable_div).css
							'position':'relative'
							'top': 0
							'left':0
						$(choice_div).data('dragged-item',variable_div)

					$('.draggable-rank-variable-box', el).draggable
						stack: "div"
						start: (event, ui) ->
							$(this).data('OrgPosition', $(this).position())
							$(this).data('parent', $(this).parent())

						stop: (event, ui) ->
							if $(this).parent()[0] == $(this).data('parent')[0]
								$(this).css
									'position':'absolute'
									'top': $(this).data('OrgPosition').top
									'left': $(this).data('OrgPosition').left
								relative_position = $(this).offset()
								$(this).css
									'position':'relative'
								$(this).offset(relative_position)

					$(".rank-variable-bin", el).droppable
						accept: (dropElem) ->
							$(dropElem).hasClass("draggable-rank-variable-box")

						activeClass: "ui-state-hover"
						hoverClass: "ui-state-active"
						drop: ( event, ui ) ->
							parent = $(ui.draggable).parent()
							id = $('.variable_index', ui.draggable).text()
							if $(parent).hasClass('droppable-rank-variable-box')
								$("input[name=#{id}]", original).prop('checked', false).trigger('keyup')
								$(parent).data('dragged-item', '')
								$(this).append(ui.draggable)
								$(ui.draggable).css
									'position':'relative'
									'top': 0
									'left':0
								$(parent).children('.droppable-rank-variable-text').show()

					$(".droppable-rank-variable-box", el).droppable
						accept: (dropElem) ->
							$(dropElem).hasClass("draggable-rank-variable-box")

						activeClass: "ui-state-hover"
						hoverClass: "ui-state-active"
						drop: ( event, ui ) ->
							parent = $(ui.draggable).parent()
							rank = $(@).find('.rank_index').text()
							drag_rank = $('.rank_index', parent).text()
							if $(this).data('dragged-item') and $(this).data('dragged-item') != ''
								if $(parent).hasClass('droppable-rank-variable-box')
									$("input[value=#{rank}]", original).prop('checked', false).trigger('change')
									$("input#id_#{$('.variable_index', $(this).data('dragged-item')).text()}_#{drag_rank}").prop('checked', true).trigger('change')
									parent.data('dragged-item', $(this).data('dragged-item'))
									parent.children('.rank_index, .droppable-rank-variable-text').hide()
									parent.append($(this).data('dragged-item'))
									$(this).data('dragged-item').css
										'position':'relative'
										'top': 0
										'left':0
								else
									$("input#id_#{$('.variable_index', $(this).data('dragged-item')).text()}_#{$('.rank_index', this).text()}").prop('checked', false).trigger('keyup')
									$('.rank-variable-bin',el).append($(this).data('dragged-item'))
							else if $(parent).hasClass('droppable-rank-variable-box')
								$(parent).data('dragged-item', '')
								$(parent).children('.droppable-rank-variable-text').show()
							$("input[value=#{rank}]", original).prop('checked', false).trigger('change')
							$("input#id_#{$('.variable_index', ui.draggable).text()}_#{rank}").prop('checked', true).trigger('change')
							$(this).children('.droppable-rank-variable-text').hide()
							$(this).append(ui.draggable)
							$(ui.draggable).css
								'position':'relative'
								'top': 0
								'left':0
							$(this).data('dragged-item',ui.draggable)

		#signature renderer
		el.bind 'initialize', ->
			delimiter = '/~/'
			$('.signature').each (i, element) ->
				$(element).jSignature(height:200)
				existingSig = $(element).nextAll('input').first().val();
				existingbase30 = existingSig.split(delimiter)[0]

				if (existingbase30[0])
					$(element).jSignature('setData', existingbase30)

			$('.signature').bind 'change', (e) ->
				data = $(e.target).jSignature("getData", "base30")
				url = "data:" + data.join(",")
				base64 = $(e.target).jSignature("getData", "svgbase64")[1]
				inputField = $(e.target).nextAll('input').first()
				inputField.val(url + delimiter + base64)
			$('.reset-signature').click (event) ->
				$(event.target).parent().prevAll('.signature').first().jSignature('clear')
				$(event.target).parent().prevAll('input').first().val('')

		el.bind 'initialize', ->

			# Stand Alone Slider Question
			$.each $(".slider_question"), (i, el) ->
				$('input', $(el).parent()).hide();

				minimumValue = $('span.minimumValue', this).html();
				maximumValue = $('span.maximumValue', this).html();
				stepSize = $('span.stepSize', this).html();
				initialValue = $('input', $(this).parent()).val() or $('span.initialValue', this).html() ;

				if minimumValue == 'undefined'
					minimumValue = 1

				if maximumValue == 'undefined'
					maximumValue = 100

				if stepSize == 'undefined'
					stepSize = 1

				#if initialValue == '' && $('input', $(el).parent()).val() == ''
					#$('input', $(el).parent()).val(minimumValue);
				#else
				#	$('input', $(el).parent()).val(initialValue)

				slideroptions =
					min: parseFloat minimumValue
					max: parseFloat maximumValue
					step: parseFloat stepSize
					slide: (event, ui) ->
						$($('input', $(this).parent())[0]).val(ui.value).trigger('change')

						$('a', this).data('tooltip').text($($('input', $($(this).parent()).parent())[0]).val())

						$('a', el).data('tooltip').position
							my: 'center top'
							at: 'center bottom'
							of: $('a', el)
							offset: '0 -50'

					stop: (event, ui) ->
						$('a', el).data('tooltip').position
							my: 'center top'
							at: 'center bottom'
							of: $('a', el)
							offset: '0 -50'

					value: initialValue


				$(el).slider(slideroptions);

			chide.ui.Tooltip.init($('a.ui-slider-handle', '.slider_question'), {'focus': true, 'offset': '0 -50'});

		refreshCheckbox = (el) ->
			if el.is('.na-choice')
				if el.attr('checked')
					el.closest('li').siblings().find(':checkbox').removeAttr('checked').end()
						.find('input.other').val('').end()
			else if el.is('.check-all')
						if el.attr('checked')
							el.closest('li').siblings().find(':checkbox.na-choice').removeAttr('checked')
							el.closest('li').siblings().find(':checkbox:not(.na-choice)').attr('checked','')
						else
							el.closest('li').siblings().find(':checkbox:not(.na-choice)').removeAttr('checked')
			else
				boxes_not_na=el.closest('li').siblings().find(':checkbox:not(.na-choice):not(.check-all)')
				boxes_not_checked=el.closest('li').siblings().find(':checkbox[checked]:not(.na-choice):not(.check-all)')
				if  el.attr('checked')
					el.closest('li').siblings().find(':checkbox.na-choice').removeAttr('checked').end()
					if boxes_not_na.size()==boxes_not_checked.size()
						el.closest('li').siblings().find(':checkbox.check-all').attr('checked','')
				else el.closest('li').siblings().find(':checkbox.check-all').removeAttr('checked')

		# exclusive checkboxes
		el.delegate '.question:has(.na-choice) :checkbox,.question:has(.check-all) :checkbox' , 'change', (e) ->
			refreshCheckbox $(e.target)

		# auto-select radio buttons and checkboxes
		el.delegate 'input.other', 'keypress', (e) ->
			return unless e.keyCode != 9

			refreshCheckbox $(e.target).closest('li').find(':checkbox, :radio').attr('checked', 'checked')

		el.delegate 'td:has(:checkbox, :radio)', 'click', (e) ->
			if e.target and $(e.target).is('td')
				$(':checkbox, :radio', this).focus().click()

		# date/time handlers
		el.delegate 'input.date', 'focus', (e) ->
			$(this).datepicker
				changeMonth: true
				changeYear: true
				yearRange: '-90:+20'
				dateFormat: 'yy/mm/dd'

			$(this).datepicker('show')

		el.delegate 'input.month-day', 'focus', (e) ->
			minDate = new _.date()
			minDate.setMonth(0)
			minDate.setDate(1)
			maxDate = new _.date()
			maxDate.setMonth(11)
			maxDate.setDate(31)

			$(this).datepicker
				changeMonth: true
				changeYear: false
				minDate: minDate
				maxDate: maxDate
				dateFormat: 'mm/dd'

			$(this).datepicker('show')

		el.delegate 'a.datetime-now', 'click', (e) ->
			e.preventDefault()

			now = new _.date()

			$(this).closest('.question').find(':input[name$=_date]').val(now.format("yyyy/MM/dd"))
			$(this).closest('.question').find(':input[name$=_time]').val(now.format("HH:MM:ss"))


class ClientHandler extends Handler
	restartTimeout: undefined

	initializeContent: (el, autorender) ->
		@el = el

		_.bindAll this, 'onFormSubmit', 'onLanguageChange', 'onBackClicked', 'restart', 'onAnyInputChanged', 'onPageLinkClicked'

		@el.delegate 'form.survey-form', 'submit', @onFormSubmit
		@el.delegate 'form.language-select', 'submit', @onLanguageChange
		@el.delegate 'input.back', 'click', @onBackClicked

		@initializeBehaviors @el

		@currentPage = @survey.pages[0]

		@renderPage @currentPage if not autorender? or autorender

		@el.delegate ':input', 'change keyup', @onAnyInputChanged

		@el.delegate 'a[data-goto-page]', 'click', @onPageLinkClicked

	onBackClicked: (e) ->
		e.preventDefault()

		@response.saveForm @el, @currentPage

		newPage = @getPreviousPage(@currentPage)

		@renderPage newPage if newPage?

	onPageLinkClicked: (e) ->
		@renderPage @survey.loopedPages()[parseInt($(e.target).data('goto-page'), 10)]

	onFormSubmit: (e) ->
		e.preventDefault()

		@response.saveForm @el, @currentPage

		return unless @validate(@currentPage)

		newPage = @getNextPage(@currentPage)

		if not newPage? or newPage == 'f'
			@response.completed = 1
			@response.save()
			@renderFinishPage()
		else if newPage == 't'
			@response.completed = 2
			@response.save()
			@renderTerminatePage()
		else
			@renderPage(newPage)

	onLanguageChange: (e) ->
		e.preventDefault()

		@response.saveForm @el, @currentPage

		trans::language = $('select[name=l]', e.target).val()

		@renderPage @currentPage

	onAnyInputChanged: (e) ->
		# FIXME: this might be slow, probably a better way to do this
		@response.saveForm @el, @currentPage
		@updatePiping @el, @currentPage
		@currentPage.applyTargetRules this, @el

	renderSurveyHeader: (page)->
		if not @progressBar and not @options.get('disable_progress_bar')
			@progressBar = $(@progressBarTemplate(progress: @getProgress(page)))
		header = super(page)
			.find('.right')
			.append(@progressBar ? '')
			.end()

	renderPage: (page) ->

		@el.attr 'data-enhance', 'false'

		@el.empty().append(@renderSurveyHeader(page))

		@currentPage = page

		el = super(page).appendTo(@el)

		$(window).scrollTop(0)

		myel = @el;

		cont = ->
			myel.removeAttr 'data-enhance'
			myel.trigger 'create'
			myel.trigger 'initialize'


		if Mobilizr?
			Mobilizr.reset()
			Mobilizr.auto =>
				# need to re-run dynamics post-mobilization
				page.applyTargetRules @, myel
				cont()
		else
			cont()

		$('#survey .progress-bar').find('.bar').width('100%').css('left', "#{ -100 + @getProgress(page)}%").end().find('.progress').text("#{@getProgress(page)}%").end()

	restart: ->
		@restartTimeout = undefined
		@response = new LocalResponse(@survey)
		@renderPage @survey.pages[0]

	renderFinishPage: () ->
		super().appendTo(@el.empty().append(@renderSurveyHeader('f')))

		$('#survey .progress-bar').find('.bar').width('100%').css('left', "0").end().find('.progress').text("#{@getProgress('f')}%").end()

		@surveyFinished()

	renderTerminatePage: () ->
		super().appendTo(@el.empty().append(@renderSurveyHeader('t')))

		@surveyFinished()

	surveyFinished: ->
		e = $.Event('finished')

		$(this).trigger(e)

		if e.isDefaultPrevented()
			return

		@restartTimeout = setTimeout @restart, 4000

		@currentPage = null


_.extend exports, {
	Page
}
